// Libs
import React from 'react';
import { withRouter } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import moment from 'moment';

// Services & Helpers
import GlobalStateService from 'services/GlobalStateService';
import DevTaskService from 'services/DevTaskService';
import TageService from 'services/TagService';

// Components
import Loader from 'components/common/Loader';
import EditDevTaskModal from 'components/admin/dev-tasks/EditDevTaskModal';
import PageHeader from 'components/common/PageHeader';
import SideBar from 'components/common/SideBar';
import FormChecks from 'components/common/FormChecks';

//-------------------------------------------------------------------------------------------------------------------

class DevTasksPage extends React.Component {

    constructor(props) {
        super(props);

        this.editDevTaskModalRef = React.createRef();

        this.requestID = 1;
        this.state = {
            isLoading: true,
            isLoadingFilters: true,
            filters: {
                statuses: {
                    New: true,
                    Queued: true,
                    WorkingOn: true,
                    NeedMoreInfo: true,
                    DoneOnDev: true,
                    Testing: true
                },
                tagIDs: { 0: true }
            }
        };
    }
    
    async componentDidMount() {
        GlobalStateService.setValues({ area: 'dev-tasks' });
        window.scrollTo(0, 0);
        this.loadFilters();
    }

    async loadFilters() {
        const tags = await TageService.list({ type: 'DevTask' });
        const filters = { ...this.state.filters };
        tags.forEach(t => filters.tagIDs[t.id] = true);
        this.setState({
            tags,
            filters,
            isLoadingFilters: false
        }, () => {
            this.load();
        });
    }

    async load() {
        const devTasks = await DevTaskService.list(this.state.filters);
        this.setState({
            devTasks,
            isLoading: false,
            isDirty: false
        });
    }

    async editDevTask(devTask) {
        await this.editDevTaskModalRef.current.show({
            devTaskID: devTask.id
        });
        this.load();
    }

    async addDevTask() {
        await this.editDevTaskModalRef.current.show({
        });
        this.load();
    }

    updateFilter(name, value) {
        const filters = { ...this.state.filters };
        filters[name] = value;
        this.setState({
            filters,
            isDirty: true
        });
    }

    updateFilterOptions(filterName, values) {
        const filters = { ...this.state.filters };
        const filter = { ...filters[filterName] };
        for (let option in values) {
            const value = values[option];
            if (value) {
                filter[option] = value;
            } else {
                delete filter[option];
            }
        }
        filters[filterName] = filter;
        this.updateFilter(filterName, filter);
    }

    render() {
        return (<>
            <div className="page dev-tasks-page full-width-page">

                <PageHeader hasSideBar>
                    <h1>Development Tasks</h1>

                    <div className="buttons">

                        <button className="btn btn-primary" onClick={e => this.addDevTask()}>
                            <span className="fa-solid fa-plus"></span>{' '}
                            New task
                        </button>

                    </div>

                </PageHeader>

                <main>

                    <SideBar content={this.renderSideBarContent()} className="flex" />

                    <Container fluid>

                        <section>

                            {this.renderInner()}

                        </section>

                    </Container>

                </main>

            </div>

            <EditDevTaskModal ref={this.editDevTaskModalRef} />

        </>);
    }

    renderInner() {
        const {
            isLoading,
            devTasks
        } = this.state;

        if (isLoading) {
            return (<Loader />);
        }

        return (

            <div className="sticky-table-container scrolling">

                <table className="table table-bordered sticky-table selectable dev-tasks-table">
                    <thead>
                        <tr>
                            <th className="num-col">#</th>
                            <th className="title-col">Title</th>
                            <th className="tags-col">Tags</th>
                            <th className="added-by-user-col">Requested By</th>
                            {/*<th className="est-completion-date-col">Est. Completion</th>*/}
                            <th className="status-col">Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {devTasks.map(dt =>
                            <tr key={dt.id} onClick={e => this.editDevTask(dt)}>
                                <td className="num-col">{dt.id}</td>
                                <td className="title-col">{dt.title}</td>
                                <td className="tags-col">
                                    {dt.tags.length > 0 &&
                                        <div className="tag-list">
                                            {dt.tags.map(dtt =>
                                                <span key={dtt.name} className="tag" style={{ backgroundColor: dtt.backColour, color: dtt.textColour }}>
                                                    {dtt.name}
                                                </span>
                                            )}
                                        </div>
                                    }
                                </td>
                                <td className="added-by-user-col">{dt.addedByUser ? `${dt.addedByUser.firstName || ''} ${dt.addedByUser.lastName || ''}` : ''}</td>
                                {/*<td className="est-completion-col">
                                    {dt.estCompletionDate ? moment(dt.estCompletionDate).format('DD/MM/YYYY') : ''}
                                </td>
                                */}
                                <td className="status-col">{DevTaskService.getStatusFriendly(dt.status)}</td>
                            </tr>
                        )}
                    </tbody>
                </table>

            </div>

        );
    }
    
    renderSideBarContent() {
        const {
            isLoadingFilters,
            isLoading,
            filters,
            isDirty
        } = this.state;
         
        if (isLoadingFilters) {
            return (<Loader />);
        }

        const tags = [...this.state.tags].concat({ name: 'No tags', id: 0 });

        return (<>

            <FormChecks
                isScrolling
                allowSelectAllNone
                isConcertina
                isOpenByDefault
                includeFormGroup
                className="mb-3"
                name="Statuses"
                id="statuses"
                options={DevTaskService.listStatuses().map(s => ({
                    id: s,
                    name: DevTaskService.getStatusFriendly(s)
                }))}
                value={filters.statuses}
                onChange={(values) => this.updateFilterOptions('statuses', values)}
            />

            <FormChecks
                isScrolling
                allowSelectAllNone
                isConcertina
                isOpenByDefault
                includeFormGroup
                className="mb-3"
                name="Tags"
                id="tagIDs"
                options={tags}
                value={filters.tagIDs}
                onChange={(values) => this.updateFilterOptions('tagIDs', values)}
            />

            <button type="button" className="btn btn-primary w-100 mt-auto" disabled={isLoading} onClick={() => this.load()}>
                Load tasks {isDirty ? ' *' : ''}
            </button>
                
        </>);
    }
}

export default withRouter(DevTasksPage);